import { formatDate, todayDate } from '../dateFunctions';
import { QUALITY, SUPERUSER } from '../userRoles';

export const ADDRESS_LINE_1_MAX_LENGTH = 100;
export const ADDRESS_LINE_2_MAX_LENGTH = 100;
export const ADDRESS_LINE_3_MAX_LENGTH = 100;
export const ADDRESS_LINE_4_MAX_LENGTH = 100;
export const MAX_BUSINESS_NAME = 50;
export const CITY_MAX_LENGTH = 30;
export const COUNTY_MAX_LENGTH = 30;
export const DEFAULT_TABLE_ROW_OPTIONS = [5, 10, 25, 50, 100];
export const DEFAULT_TABLE_ROWS_PER_PAGE = 10;
export const FIFTY_TABLE_ROWS_PER_PAGE = 50;
export const INVALID_POSTCODE = 'Invalid postcode';
export const INVALID_EMAIL_ADDRESS = 'Invalid email address';
export const MAX_TABLE_ROWS_PER_PAGE = 100;
export const MIN_EMAIL = 7;
export const MAX_EMAIL = 254;
export const MAX_NAME = 100;
export const MIN_PHONE = 11;
export const MAX_PHONE = 15;
export const MAX_POSTCODE = 10;
export const MAX_PRONOUN = 50;
export const MIN_PTCODE = 9;
export const MAX_PTCODE = 9;
export const names = {
    NHS_NUMBER: 'NHS Number',
    NINO: 'NINO'
};
export const NHS_LENGTH = 10;
export const NO_SELECTION = '  no selection';
export const REMOTE_CALL_URL_PROVIDERS = [
    'zoom.us',
    'teams.microsoft.com',
    'webex.com',
    'meet.google.com',
    'goto.com'
];
export const MAX_URL = 500;

export const EDIT_ON_CLOSED_ROLES = [QUALITY, SUPERUSER];
export const TODAY = formatDate(todayDate());
